import { decodeCognitoToken } from "../utils/decodeCognitoToken";
import { addUserInfoFromToken } from "../utils/addUserInfoFromToken";
import { Auth } from "aws-amplify";

export const getAuthData = async (logger: any = console) => {
  try {
    const session = await Auth.currentSession();
    if (!session) throw new Error("Session is invalid");
    const idToken = session.getIdToken();
    const idTokenJwt = idToken.getJwtToken();
    const accessToken = session.getAccessToken().getJwtToken();
    const refreshToken = session.getRefreshToken().getToken();
    const [_, cognitoUser] = decodeCognitoToken({
      idToken: idTokenJwt,
      accessToken,
      refreshToken,
    });
    const userInfo = addUserInfoFromToken(idToken);
    if (logger.hasUserContext && !logger.hasUserContext()) {
      logger.setUserContext({ type: "resident", ...userInfo });
      logger.info(`${userInfo.username} is signed in!`);
    }
    return { isLoggedIn: true, userInfo, cognitoUser };
  } catch (error) {
    await logger.error(error);
    await logger.info("Signing out and going to sign-in");
    await Auth.signOut();
    return { isLoggedIn: false, userInfo: {}, cognitoUser: {} };
  }
};
